<template lang="html">
	<div class="common-mar-b">
		<van-tabs>
			<van-tab v-for="(item, index) in types" :key="index" >
				<div slot="title" @click="getThisTypeCourse(item.id)">
					{{item.type_name}}
				</div>
			</van-tab>
		</van-tabs>
		<van-row class="recommend-course course-list-container">
			<van-col span="24">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了" :immediate-check="immediateCheck">
						<div class="fix course-container">
							<div class="fl course-item" v-for="(item, index) in courses" :key="index" @click="goCourseDetail(item.id)">
								<div class="course-image-box">
									<van-image class="course-image" fit="cover" :src="imgUrl+item.course_thumbnail_image" />
									<div class="course-count"><div class="course-count-icon">{{item.course_buy_num}}</div></div>
								</div>
								<div class="course-title">{{item.course_title}}</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-col>
		</van-row>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
	import FooterNav from "../../components/footer.vue"
	import wxapi from '@/common/wxapi.js'
	export default{
		components:{
			FooterNav
		},
		data(){
			return{
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				types: [], //课程分类
				courses: [] ,//课程列表
				typeId: 0,
				isLoading: false, //控制下拉刷新的加载动画
				loading: false,//控制上拉加载的加载动画
				finished: false,//控制在页面往下移动到底部时是否调用接口获取数据
				totalPage: 0,
				pageNumber: 1,
				immediateCheck: false //是否在初始化时立即执行滚动位置检查
			}
		},
		created(){
			let that = this;
			//判断是否授权登录
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			that.$axios.post('http://sls.zhishen.net.cn/api/Course/courseIndex', formdata)
			.then(function (res) {
				that.types = res.data.course_type
				that.courses = res.data.course_list.course_list
				let option = {
					title: '读联',
					link: '',
					imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
					desc: '读联'
				}
				if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
					let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '').replace(/&$|\?$/, '');
					let newUrl = location.origin + location.pathname + newSearch + location.hash;
					location.replace(newUrl);
					option.link = newUrl
					wxapi.wxRegister(option)
				}else{
					option.link = location.href.split('&')[0]
					wxapi.wxRegister(option)
				}
			})
			.catch(function (error) {
				console.log(error);
			});
			document.title = "课程"
		},
		methods:{
			//点击课程分类
			getThisTypeCourse(id){
				let that = this
				that.typeId = id;
				let formdata = new FormData();
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('type_id', id);
				formdata.append('page', 0);
				that.$axios.post('http://sls.zhishen.net.cn/api/Course/getCourseList', formdata)
				.then(function (res) {
					that.courses = res.data.course_list
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			//点击进入课程详情
			goCourseDetail(id){
				window.location.href = this.login.pageUrl + '/coursedetail?courseId=' + id;
			},
			//下拉刷新
			onRefresh() {
				let that = this
				setTimeout(() => {
					let formdata = new FormData();
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('type_id', that.typeId);
					formdata.append('page', 0);
					that.$axios.post('http://sls.zhishen.net.cn/api/Course/getCourseList', formdata)
					.then(function (res) {
						that.courses = res.data.course_list
					})
					.catch(function (error) {
						console.log(error);
					});
					that.isLoading = false;
				}, 500);
			},
			//上拉加载
			onLoad() {
				let that = this;
				setTimeout(() => {
					let formdata = new FormData();
					formdata.append('token', localStorage.getItem('token'));
					formdata.append('type_id', that.typeId);
					formdata.append('page', that.pageNumber + 1);
					that.$axios.post('http://sls.zhishen.net.cn/api/Course/getCourseList', formdata).then(function (res) {
						that.totalPage = res.data.total_page
						if (that.pageNumber >= that.totalPage) {
							that.finished = true;
							that.loading = false;
						}else{
							that.courses = that.courses.concat(res.data.course_list)
							that.loading = false;
							that.pageNumber++;
						}
					}).catch(function (error) {
						console.log(error);
					})
				}, 500);
			}
		}
	}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/view/live/index.vue